<template>
  <div style="width:50%; left:25%; position:relative; margin-top:15px;">
    <Table highlight-row @on-current-change="selectRow" :max-height="height * 0.6" border ref="selection" :columns="columns4" :data="data1">
      <!-- <template slot-scope="{ row, index }" slot="selection"> -->
        <!-- <Checkbox @on-change="selectRow(row, $event)"></Checkbox> -->
      <!-- </template> -->
    </Table>

    <div style="padding:10px">
      <Button style type="warning" @click="clickUpdate">修改</Button>
      <Button style="margin-left:10px" type="success" @click="showAddModal=true;op='add'">新增</Button>
    </div>

    <Modal title="Title" v-model="showAddModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>选择用气类型</span>
      </p>
      <div style="text-align:center">
        <Row class="row">
          <Col span="12">
            <p>用气类型</p>
          </Col>
          <Col span="12">
            <Input v-model="gasTypeName" placeholder="请输入用气类型名称"></Input>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="info" size="large" v-if="op=='add'" long @click="addGasTypeInfo">添加</Button>
        <Button type="info" size="large" v-if="op=='update'" long @click="updateGasTypeInfo">修改</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { constants } from "crypto";
export default {
  name: "gastype",
  mounted() {
    this.getGasTypeList();
  },
  data() {
    return {
      existArray: [],
      op: 'add',
      gasTypeName: "",
      errorSelection: global.errorMsgParam,
      showAddModal: false,
      selectData: {},
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      columns4: [
        {
          title: "类型编号",
          key: "gasTypeId",
          align: "center"
        },
        {
          title: "用气类型",
          key: "gasTypeName",
          align: "center"
        }
      ],
      data1: []
    };
  },
  methods: {
    clickUpdate() {
      // if(){
      //   this.selectData = currentRow;
      // }
      this.showAddModal = true;
      this.op = 'update';
    },
    updateGasTypeInfo() {
      //console.log(this.selectData);
      if (Object.keys(this.selectData) == 0) {
        this.$Modal.info({
          title: "提示",
          content: "请选择需修改信息！"
        });
        return;
      }
      var that = this;
      $.ajax({
        url: "/api/ladderPrice/updateGasTypeInfo",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          updateInfo: that.selectData,
          newName: that.gasTypeName
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Modal.error({
              title: "提示",
              content: data.errorInfo
            });

            return;
          } else {
            that.$Modal.success({
              title: "提示",
              content: "修改成功"
            });
          }
        },
        
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.getGasTypeList();
          that.showAddModal = false;
        }
      });
    },
    addGasTypeInfo() {
      if (this.gasTypeName == "") {
        this.$Modal.info({
          title: "提示",
          content: "请填写新增用气类型名称！"
        });
        return;
      }

      var that = this;
      $.ajax({
        url: "/api/ladderPrice/addGasTypeInfo",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          addInfo: that.gasTypeName
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Modal.error({
              title: "提示",
              content: data.errorInfo
            });

            return;
          } else {
            // 当前用户微信未进行绑定
            that.$Modal.success({
              title: "提示",
              content: "新增成功"
            });
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.getGasTypeList();
          that.showAddModal = false;
        }
      });
    },
    selectRow(currentRow, oldCurrentRow) {
        this.selectData = currentRow;
    },
    handleSelectAll(status) {
    },

    getGasTypeList() {
      var that = this;
      var result = {};
      $.ajax({
        url: "/api/ladderPrice/selectAllGasType",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Modal.error({
              title: "提示",
              content: data.errorInfo
            });
            return;
          } else {
            that.data1 = data.body.origin;
          }
          console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.selectData = {};
        }
      });
    }
  }
};
</script>